import { Controller } from "stimulus";

export default class DomainController extends Controller {
  submitForm(event) {
    event.target.closest("form").requestSubmit();
  }
}
